import { cn } from "@/lib/utils";

export function PremiumBadge({ className, position }: { className?: string; position?: "top" | "right" }) {
  return (
    <div className={cn("rounded bg-orange-100 px-2 py-1 text-xs font-semibold leading-tight text-orange-500", position === "top" && "absolute left-1/2 top-0 -translate-x-1/2", position === "right" && "absolute right-2 top-1/2 -translate-y-1/2", className)}>
      Premium
    </div>
  );
}
